import { Property } from "@firecms/core";

export function flattenProperties(
  properties: Record<string, Property>,
  prefix = "",
): { key: string; property: Property }[] {
  const result: { key: string; property: Property }[] = [];
  for (const [key, prop] of Object.entries(properties)) {
    const property = prop as Property;
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (property.dataType === "map" && property.properties) {
      result.push(...flattenProperties(property.properties as Record<string, Property>, fullKey));
    } else {
      result.push({ key: fullKey, property });
    }
  }
  return result;
}

export function stringifyValue(value: unknown, property: Property): string {
  if (value === undefined || value === null) return "";
  switch (property.dataType) {
    case "date":
      return value instanceof Date ? value.toISOString() : typeof value === "string" ? value : "";
    case "boolean":
      return value ? "true" : "false";
    case "number":
      return value.toString();
    case "string":
      return typeof value === "string" ? value : "";
    case "reference":
      return typeof value === "object" && value !== null && "id" in value
        ? (value as { id: string }).id
        : value?.toString() || "";
    case "array":
      return Array.isArray(value) ? value.map((v) => v?.toString()).join(", ") : "";
    case "map":
      return typeof value === "object" ? JSON.stringify(value) : "";
    default:
      return value?.toString() || "";
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getNestedValue(obj: any, keyPath: string): any {
  const keyParts = keyPath.split(".");
  let value = obj;
  for (const part of keyParts) {
    value = value?.[part];
    if (value === undefined) break;
  }
  return value;
}

export function generateCSVContent(headers: string[], rows: Record<string, string>[]): string {
  return [
    headers.join(","),
    ...rows.map((row) =>
      headers
        .map((header) => {
          const value = row[header]?.toString() || "";
          return `"${value.replace(/"/g, '""')}"`;
        })
        .join(","),
    ),
  ].join("\n");
}

export function downloadCSV(csvContent: string, fileName: string): void {
  const link = document.createElement("a");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
